import { combineReducers, applyMiddleware, compose, createStore, AnyAction } from "redux";
import thunkMiddleware from "redux-thunk";

export interface StoreState {
    hoverIndexes?: any;
    tableDims?: any;
    fixedTableDims?: any;
}

export interface ExtraDispatchArguments {}

export function createReducer(initialState: any, handlers: any) {
    return function reducer(state = initialState, action: AnyAction) {
        if (handlers.hasOwnProperty(action.type)) return handlers[action.type](state, action);
        else return state;
    };
}

/**
 *
 * Simplifies the process of dispatching an action
 *
 * @param type: The type to be dispatched
 * @param data: The data to be dispatched
 * @return object:
 *
 */

export function setState(type: any, { data }: any) {
    return {
        type: type,
        data,
    };
}

function configureStore(initialState: any) {
    const enhancer = compose(applyMiddleware(thunkMiddleware));

    return createStore(
        makeRootReducer({
            empty: createReducer(null, {
                ["EMPTY"](_: string, action: string) {
                    return action;
                },
            }),
        }),
        initialState,
        enhancer
    );
}

export const makeRootReducer = (asyncReducers: any) => {
    return combineReducers(Object.assign({}, asyncReducers));
};

export const injectReducer = (store: any, { key, reducer }: { key: string; reducer: any }) => {
    if (!store || Object.hasOwnProperty.call(store.asyncReducers, key)) return;

    store.asyncReducers[key] = reducer;
    store.replaceReducer(makeRootReducer(store.asyncReducers));
};

const Store: any = configureStore({});
Store.asyncReducers = {};

export default Store;
